import initStore from './initStore.js';
export default function initSession( args ){

  let { 
    initialState,
    remoteDevTools=true,
    websocketTarget,
    windowSessionId,
    agentId,
    personId
  } = args;


  let store = initStore({ initialState, remoteDevTools, windowSessionId, agentId, personId })

  let session = { store }

  return session;
}
